<div class="staging-badge">
    {{ text }}
</div>